const WHATSAPP_SUFFIX_TO_TYPE = {
  ".notify": "NOTIFY_USER",
  ".await": "AWAIT_USER_REPLY",
};

const PALETTE_TO_BACKEND_TYPE = {
  "generic.condition": "CONDITION",
  "generic.collect_input": "COLLECT_INPUT",
  "generic.action": "ACTION",
  "generic.handoff": "HANDOFF",
  "generic.end": "END",
  "generic.invoke_workflow": "INVOKE_WORKFLOW",
  "generic.transfer_workflow": "TRANSFER_WORKFLOW",
};

export function serializeWorkflowForBackend(workflow) {
  if (!workflow) return workflow;

  const serialized = JSON.parse(JSON.stringify(workflow));
  const definition = serialized.definition;
  if (!definition) return serialized;

  if (definition.nodes && Array.isArray(definition.nodes)) {
    definition.nodes = definition.nodes.map((node) => {
      if (!node) return node;

      const paletteType = node.paletteType;
      // Derive backend type and channel from paletteType
      if (paletteType) {
        if (typeof paletteType === "string" && paletteType.startsWith("whatsapp.")) {
          node.channel = "whatsapp";
          const suffix = Object.keys(WHATSAPP_SUFFIX_TO_TYPE).find((s) =>
            paletteType.endsWith(s)
          );
          node.type = suffix ? WHATSAPP_SUFFIX_TO_TYPE[suffix] : "SEND_MESSAGE";
        } else {
          // Map other palette types to backend type
          const mapped = PALETTE_TO_BACKEND_TYPE[paletteType];
          if (mapped) {
            node.type = mapped;
          } else if (typeof paletteType === "string" && paletteType.startsWith("custom.")) {
            node.type = "ACTION";
          }
        }
      }

      // Remove UI/canvas-only fields from the node
      delete node.paletteType;

      const config = node.config;
      if (config && typeof config === "object") {
        const message = config.message;
        if (message && typeof message === "object") {
          const components = message.components;
          if (Array.isArray(components)) {
            components.forEach((comp) => {
              if (!comp) return;

              if (comp.type === "button") {
                const btnIndex = comp.index || "0";
                if (Array.isArray(comp.parameters)) {
                  comp.parameters.forEach((param, pIdx) => {
                    if (param.text === "" || param.text == null) {
                      const key = `button_${btnIndex}_${pIdx}`;
                      let val = null;
                      if (message.templateParams && typeof message.templateParams === "object") {
                        const tp = message.templateParams;
                        if (tp.button && typeof tp.button === "object" && tp.button[key] !== undefined) {
                          val = tp.button[key];
                        } else if (tp[key] !== undefined) {
                          val = tp[key];
                        } else if (tp.code !== undefined && pIdx === 0) {
                          val = tp.code;
                        }
                      }
                      if (val != null) {
                        param.text = String(val);
                      }
                    }
                  });
                }
              } else {
                // Header or body parameter
                if (Array.isArray(comp.parameters)) {
                  comp.parameters.forEach((param) => {
                    if (param.parameter_name) {
                      let val = null;
                      // 1. Look in templateParams
                      if (message.templateParams && typeof message.templateParams === "object") {
                        const tp = message.templateParams;
                        if (tp.header && typeof tp.header === "object" && tp.header[param.parameter_name] !== undefined) {
                          val = tp.header[param.parameter_name];
                        } else if (tp.body && typeof tp.body === "object" && tp.body[param.parameter_name] !== undefined) {
                          val = tp.body[param.parameter_name];
                        } else if (tp[param.parameter_name] !== undefined) {
                          val = tp[param.parameter_name];
                        }
                      }
                      // 2. Look in bodyParams
                      if (val == null && message.bodyParams && typeof message.bodyParams === "object") {
                        if (message.bodyParams[param.parameter_name] !== undefined) {
                          val = message.bodyParams[param.parameter_name];
                        }
                      }
                      // 3. Look in headerParams
                      if (val == null && message.headerParams && typeof message.headerParams === "object") {
                        if (message.headerParams[param.parameter_name] !== undefined) {
                          val = message.headerParams[param.parameter_name];
                        }
                      }
                      if (val != null) {
                        param.text = String(val);
                      }
                    }
                  });
                }
              }
            });
          }

          // Strip UI/canvas-only fields inside message
          delete message.headerText;
          delete message.templateName;
          delete message.bodyParams;
          delete message.templateParams;
          delete message.headerImageLink;
          delete message.body;
        }
      }

      return node;
    });
  }

  // Ensure routing has both description and examples
  if (definition.routing || definition.intent) {
    if (!definition.routing) {
      definition.routing = {};
    }
    definition.routing.description = definition.routing.description ?? "";
    definition.routing.examples = definition.routing.examples ?? [];
  }

  return serialized;
}
